import { FC, useState } from "react";
import styled from "styled-components";
import { SignIinSettingProps, SignInSetting } from "./SignInSetting";
import AddPaymentModal from "../AddPaymentModal";
import { Connections } from "./Connections";
import { AccountMgt, AccountMgtProps } from "./AccountMgt";
import { PaymentPlan } from "./PaymentPlan";


const Container = styled.div`
  margin: 0 auto;
  padding: 20px 40px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  background-color: #f8f9fa;
  font-family: "Manrope", sans-serif;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 10px;
  }
`;

const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Card = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: relative;
`;

const ProfileDetailsCard = styled(Card)``;

const AccountSettingsCard = styled(Card)``;

const ContentCard = styled(Card)``;

const SubscriptionCard = styled(Card)``;

const CoursesCard = styled(Card)`
  display: flex;
  flex-direction: column;
`;

const ProfileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
`;

const Avatar = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #5575f7;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const UserName = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
`;

const UserEmail = styled.p`
  margin: 0;
  font-size: 14px;
  color: #6c757d;
`;

const EditProfile = styled.div`
  color: #5575f7;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
`;

const CardTitle = styled.h3`
  margin: 0 0 20px 0;
  font-size: 16px;
  font-weight: 600;
  color: #212529;
`;

const SectionTitle = styled.h2`
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 600;
  color: #5575f7;
`;

const NavItem = styled.div`
  padding: 12px 0;
  cursor: pointer;
  font-size: 14px;
  color: #6c757d;

  &.active {
    color: #5575f7;
    font-weight: 500;
    border-left: 2px solid #5575f7;
    padding-left: 10px;
    margin-left: -10px;
  }
`;

const FormWrapper = styled.div`
  margin-bottom: 30px;
`;
export interface TabContentProps extends 
Pick<SignIinSettingProps, "onChangePassword">,
Pick<AccountMgtProps, "onDeleteAccount">{

}
type ITab = "signIn"|"paymentPlan"|"connections"|"accountMgt"
export const TabContent:FC<TabContentProps> = ({
  onChangePassword, onDeleteAccount
}) => {

    const [tab, setTab] = useState<ITab>("signIn")

    return <>
        <AccountSettingsCard>
          <CardTitle>Account settings</CardTitle>
          <NavItem
            className={tab === "signIn" ? "active" : ""}
            onClick={() => setTab("signIn")}
          >
            Sign in preferences
          </NavItem>
          {/* <NavItem
            className={tab === "paymentPlan" ? "active" : ""}
            onClick={() => setTab("paymentPlan")}
          >
            Payment plan
          </NavItem>
          <NavItem
            className={tab === "connections" ? "active" : ""}
            onClick={() => setTab("connections")}
          >
            Connections
          </NavItem> */}
          <NavItem
            className={tab === "accountMgt" ? "active" : ""}
            onClick={() => setTab("accountMgt")}
          >
            Manage account
          </NavItem>
        </AccountSettingsCard>
        <ContentCard>
          {tab === "signIn" && <SignInSetting {...{
            onChangePassword
          }}/>} 
          
          {tab === "paymentPlan" && <PaymentPlan />} 
          {tab === "connections" && <Connections />} 
          {tab === "accountMgt" && <AccountMgt {...{ onDeleteAccount }} />} 

        </ContentCard>
    </>
}